import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import AdoptionRequestsTable from '@/tables/AdoptionRequestsTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/adoption-requests',
)({
  component: StudentsScreen,
});

function StudentsScreen() {
  const { t } = useTranslation();
  const { groupName } = Route.useParams();
  // Same query and key as the `/students` layout guard, so this costs no extra
  // request. Not gated here: the endpoint's own admin and group-type
  // requirement is the real gate.
  const { data: groupData } = api.getGroupBySlug.useQuery({
    path: { group_slug: groupName },
  });

  return (
    <>
      <GroupHeaderWrapper>
        <TitleWithQuestion title={t('lessons.students')} placement="students" />
      </GroupHeaderWrapper>
      <AdoptionRequestsTable groupId={groupData?.id} />
    </>
  );
}
